var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('StandardButton',{staticStyle:{"margin-left":"3px","margin-right":"3px"},attrs:{"loading":_vm.saveInProgress,"minWidth":"80"},on:{"click":_vm.save}},[_vm._v(" Save ")])
}
var staticRenderFns = []

export { render, staticRenderFns }